import React from "react";
import styles from "./BetTableLucky15.module.css";

const BetRow = ({ bet, index, onBetClick, getExposure }) => {
  const exposure = getExposure(bet.type, bet.betData?.nat);
  const showExposure = exposure !== 0 && !isNaN(exposure);

  return (
    <div key={index} className={styles.betRow}>
      <div className={styles.betType}>{bet.type}</div>

      <div className={`${styles.betCell} ${bet.isLocked ? styles.suspendedBox : ""}`}>
        <div
          className={styles.odds}
          onClick={() => {
            if (!bet.isLocked) onBetClick && onBetClick(bet.odds, bet.type, bet.betData);
          }}
          style={{ cursor: bet.isLocked ? 'not-allowed' : 'pointer' }}
        >
          {!bet.isLocked && (
            <>
              <span className={styles.marketOdd}>{bet.odds}</span>
              <span className={styles.limit}>{bet.limit || "-"}</span>
              <div style={{ 
                fontSize: '12px', 
                color: 'black',
                fontWeight: 'bold',
                lineHeight: '1',
                marginTop: '2px'
              }}>
                {showExposure ? (exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`) : "0"}
              </div>
            </>
          )}
        </div>
      </div>

      <div className={styles.minMax}>
        <div className={styles.fancyMinMax}>
          <span className={styles.min}>Min: {bet.min || "50.00"}</span>
          <span className={styles.max}>Max: {bet.max || "25K"}</span>
        </div>
      </div>
    </div>
  );
};

export default function BetTableLucky15({ data, onBetClick, exposures = {} }) {
  // Define the order of indices to match logical flow: 0 Runs, 1 Run, 2 Runs, 4 Runs, 6 Runs, Wicket
  // Indices: 0, 2, 4, 1, 3, 5
  const orderedIndices = [0, 2, 4, 1, 3, 5];

  const bets = orderedIndices.map(index => ({
    type: data?.[index]?.nat || getDefaultLabel(index),
    odds: data?.[index]?.b,
    limit: data?.[index]?.bs,
    min: data?.[index]?.min,
    max: data?.[index]?.max,
    isLocked: isLocked(data?.[index]?.b, data?.[index]),
    betData: data?.[index]
  }));

  function getDefaultLabel(index) {
    switch (index) {
      case 0: return "0 Runs";
      case 2: return "1 Run";
      case 4: return "2 Runs";
      case 1: return "4 Runs";
      case 3: return "6 Runs";
      case 5: return "Wicket";
      default: return "-";
    }
  }

  function isLocked(val, betData) {
    return val === 0 || val === undefined || val === null || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  }

  // Get exposure value for a bet type
  const getExposure = (betType, nat) => {
    const exposureKeys = [
      nat,
      betType,
      nat?.toLowerCase(),
      betType?.toLowerCase(),
      betType?.replace(/\s+/g, ' ').trim(),
      nat?.replace(/\s+/g, ' ').trim(),
    ];
    
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }
    return 0;
  };

  return (
    <div className={styles.luckyTable15}>
      <div className={styles.tableContent}>
        {/* Header Row */}
        <div className={styles.headerRow}>
          <div className={`${styles.col4} ${styles.dNoneMobile}`}>
            <div className={styles.marketRow}>
              <div className={styles.emptyHeader}></div>
              <div className={styles.backHeader}>
                <div style={{ fontSize: '10px' }}>Back</div>
              </div>
              <div className={styles.emptyMinMax}></div>
            </div>
          </div>
          <div className={`${styles.col4} ${styles.dNoneMobile}`}>
            <div className={styles.marketRow}>
              <div className={styles.emptyHeader}></div>
              <div className={styles.backHeader}>
                <b>Back</b>
              </div>
              <div className={styles.emptyMinMax}></div>
            </div>
          </div>
          <div className={styles.col4}>
            <div className={styles.marketRow}>
              <div className={styles.emptyHeader}></div>
              <div className={styles.backHeader}>
                <b>Back</b>
              </div>
              <div className={styles.emptyMinMax}></div>
            </div>
          </div>
        </div>

        {/* Market Body - 3 columns on web, single column on mobile */}
        <div className={styles.marketBody}>
          {bets.map((bet, index) => (
            <div key={index} className={styles.col4}>
              <BetRow 
                bet={bet} 
                index={index} 
                onBetClick={onBetClick} 
                getExposure={getExposure}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

